import { colors } from '@mui/material';
import CONFIG from '@config';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: CONFIG.LOGIN_PRIMARY_COLOR_MAIN_DARK || '#9e2652',
    main: CONFIG.LOGIN_PRIMARY_COLOR_MAIN || '#A82956',
    light: CONFIG.LOGIN_PRIMARY_COLOR_MAIN_LIGHT || '#c93067',
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400'],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  divider: colors.grey[200],
};
